//to scroll to the next section - the sibling of the parent-element of the clicked button given via the config const parent. Mainly used on Front in project Alpiq
import Helper from './Helper';

class GoToNextSection {
  constructor(config = {}) {
    const {
      button,
      parent
    } = config;
    this.button = document.querySelector(button);
    this.parent = parent;
    if(this.button){
      this.bindEvents();
    }
  }

  bindEvents(){
    this.button.addEventListener("click", e => {
      e.preventDefault;
      let section = Helper.getClosest(this.button, this.parent);
      if(section) {
        let sectionNext = section.nextElementSibling;
        this.scrollTo(sectionNext);
      }
    });
  }

  scrollTo(element) {
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: element.offsetTop
    });
  }

}

export default GoToNextSection;
